import { render, staticRenderFns } from "./AddMedicines.vue?vue&type=template&id=f1c2a444"
import script from "./AddMedicines.vue?vue&type=script&lang=js"
export * from "./AddMedicines.vue?vue&type=script&lang=js"
import style0 from "./AddMedicines.vue?vue&type=style&index=0&id=f1c2a444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports